import { humanDateFormat } from 'client-portal/utils/date-time';
import { inject as service } from '@ember/service';
import Super from './-resources';
import moment from 'moment-timezone';

export default class SiteBillingInsurance extends Super {
  @service router;
  @service store;

  humanDateFormat = humanDateFormat;

  get routeName() {
    return this.router.currentRouteName;
  }

  get insuranceInfos() {
    return this.model.insuranceInfos;
  }

  get pendingInsuranceRequests() {
    if (!this.currentPractice.get('insuranceInfoDocumentRequestEnabled')) {
      return null;
    }

    const pendingReviews = this.store
      .peekAll('clinician-insurance-info-review')
      .filter(review => review.status === 'pending' && review.insuranceInfoRequestConnection);

    return pendingReviews.length > 0
      ? pendingReviews.map(review => review.insuranceInfoRequestConnection)
      : null;
  }

  get rejectedInsuranceRequests() {
    if (!this.currentPractice.get('insuranceInfoDocumentRequestEnabled')) {
      return [];
    }

    const sevenDaysAgo = moment().subtract(7, 'days');
    return this.store
      .peekAll('clinician-insurance-info-review')
      .filter(
        review =>
          review.status === 'denied' &&
          review.insuranceInfoRequestConnection &&
          review.reviewedAt &&
          moment(review.reviewedAt).isAfter(sevenDaysAgo)
      );
  }
}
